import { Injectable } from '@angular/core';
import { GlobalInfo, Static } from '@app/shared';
import { Observable } from 'rxjs/Observable';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { merge } from 'lodash';

@Injectable()
export class GlobalInfoService {
  // Transmite un resumen de la información guardada
  private subject = new BehaviorSubject<Partial<GlobalInfo>>({});
  // Contiene la informacion GLOBAL
  private data: Partial<GlobalInfo> = {};

  constructor() {}

  /**
   * Setea la informacion global del sistema.
   *
   * @param {Partial<GlobalInfo>} params
   * @memberof GlobalInfoService
   */
  set(params: Partial<GlobalInfo>) {
    Static.setAll(this.data, params);
    this.subject.next(this.data);
  }

  merge(params: Partial<GlobalInfo>) {
    this.data = merge(this.data, params);
    this.subject.next(this.data);
  }

  /**
   * Retorna un observable para subscribirse a la
   * información global guardada.
   *
   * @returns {Observable<Partial<GlobalInfo>>}
   * @memberof GlobalInfoService
   */
  get(): Observable<Partial<GlobalInfo>> {
    return this.subject;
  }
}



// WEBPACK FOOTER //
// ./src/app/core/utilities/global-info.service.ts